module.exports = __webpack_public_path__ + "img/logo.89bf21a9.png";